module.exports = __webpack_public_path__ + "img/1021b039524ce5d1c791af1d77aa9dae.svg";